import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';

import settings from '../assets/settings.json';

import Cookies from 'js-cookie'
import './css/search.css';


export default class Search extends Component{
  state={
    searchFormData:[],
    checked: false
  }
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount () {
    //fetch(`https://api.hello-remix.com/check_updated_at/?token=bb7773835859debab60572f21dbaf133c09ef6d16d970aa8ac921038946e7b3a&name=%E5%A4%A7%E5%B3%B6&type=inventory&val=updated_at`)
    //  .then(res => res.json())
    //  .then(json => console.log('OK'));
    this.props.changeSearch('search child');
  }
  

  //handleSubmitSearch = (e) => {
  //  console.dir(e);
  //  this.props.changeSearch('search child');
  //}


  handleChange = (e) => {
    //console.dir(e);
    this.setState({ checked: !this.state.checked });
    //console.log(!this.state.checked );
  }
  
  
  
  render(){


		const handleSubmitSearch = async (event) => {
			event.preventDefault();
			console.dir(event.target)
      let search_text = '';
      let elem_id = '';
      let elem_val = '';
      let add_text = '';
      let _add_text = '';
      let search_array = [];
      let query = '';

      for (let i = 0; i < event.target.length; i++) {
        let search_obj = {};

        elem_id = event.target[i].id;
        elem_val = event.target[i].value;
        console.log(elem_val);
        if(elem_val===undefined || elem_val===''){
          continue;
        }
        if( elem_id==='hattyuu_no'){
          elem_val = elem_val.replace(/ /g,'');
          _add_text = '発注No:'+String(elem_val);
          search_obj['発注No'] = String(elem_val);
          if(add_text===''){
            add_text = _add_text;
          }else{
            add_text = add_text+ '　' + _add_text;
          }
        }else if( elem_id==='order_key'){
          _add_text = 'KEY:'+String(elem_val);
          search_obj['KEY'] = String(elem_val);
          if(add_text===''){
            add_text = _add_text;
          }else{
            add_text = add_text+ '　' + _add_text;
          }
        }else if( elem_id==='jan'){
          _add_text = 'JAN:'+String(elem_val);
          search_obj['JAN'] = String(elem_val);
          if(add_text===''){
            add_text = _add_text;
          }else{
            add_text = add_text+ '　' + _add_text;
          }
        }else if( elem_id==='cm-order-no'){
          _add_text = '管理番号:'+String(elem_val);
          search_obj['管理番号'] = String(elem_val);
          if(add_text===''){
            add_text = _add_text;
          }else{
            add_text = add_text+ '　' + _add_text;
          }
        }

        if(Object.keys(search_obj).length){
          search_array.push(search_obj);
        }
        

      }

      console.log('add_text:'+add_text);
      console.dir(search_array);


      if(this.state.checked===false){
        this.props.changeFormDataCutHattyuu([]);
        this.props.changeSearch('browser', add_text, search_array);
      }else{
        for (let i = 0; i < event.target.length; i++) {
          console.log('query:'+query);
          elem_id = event.target[i].id;
          elem_val = event.target[i].value;
          console.log(elem_id+' '+elem_val);
          if(elem_id==='hattyuu_no' && elem_val!==''){
            query = '&hattyuu_no='+String(elem_val);
          }else if(elem_id==='hattyuu_no' && query.indexOf('hattyuu_no=') === -1){
            query = '&hattyuu_no=all';
          }

          if(elem_id==='order_key' && elem_val!==''){
            query = query + '&order_key='+String(elem_val);
          }else if(elem_id==='order_key' && query.indexOf('order_key=') === -1){
            query = query + '&order_key=all';
          }

          if(elem_id==='jan' && elem_val!==''){
            query = query + '&jan='+String(elem_val);
          }else if(elem_id==='jan' && query.indexOf('jan=') === -1){
            query = query + '&jan=all';
          }

          if(elem_id==='cm-order-no' && elem_val!==''){
            query = query + '&cm_order_no='+String(elem_val);
          }else if(elem_id==='cm-order-no' && query.indexOf('cm_order_no=') === -1){
            query = query + '&cm_order_no=all';
          }
        }

        //query = query + '&phase=all&updated_at_from=all&updated_at_to=all&deli_limit=all&hattyuu_stattus=all&tonya_name=all'
        console.log('query:'+query);
        // URL パラメーター、リロード
        let alert_box = window.confirm('画面を再読み込みして検索します。\nよろしいですか？');
        if(alert_box===false){
          return 'check_false';
        }
        let staff_token = Cookies.get('_replace_token');
        let staff_name = Cookies.get('_replace_staff');
        query = '?name='+staff_name+'&token='+staff_token+query;
        let reload = settings.DOMAIN + 'cm-list/'+query;
        console.log('reload url '+reload);
        window.location.replace(reload);

        this.props.changeSearch('server', add_text, search_array);
      }
      
			//console.dir(this.state.searchFormData);
		};

    let switch_style_1 = '';
    let switch_style_2 = '';
    if(this.state.checked===false){
      switch_style_1 = 'search-switch-label radio-board-label-on';
      switch_style_2 = 'search-switch-label';
    }else{
      switch_style_1 = 'search-switch-label';
      switch_style_2 = 'search-switch-label radio-board-label-on';
    }


		var searchClearClick = async (e) => {
			console.dir(e.target);
      if(this.state.checked===false){
        this.props.changeSearch('browser', '', []);
        document.getElementById("search-form").reset();
        this.props.changeFormDataCutHattyuu([]);
      }else{
        window.location.replace(settings.DOMAIN+'cm-list');
      }
		}



    return (
      <div className="search-area bg-light">
    		<Form onSubmit={handleSubmitSearch} className="form-control-select" id="search-form">
          <Row className="g-2 " size="sm">
            
            {/* <Col className="col-1"></Col> */}
            
            {/* 
            <Col >
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Text id="phase">引き当て</InputGroup.Text>
                <Form.Select aria-label="">
                  <option value="hikiate_all">関係なし</option>
                  <option value="hikiate_zumi">引き当て済</option>
                  <option value="hikiate_nashi">未引き当て</option>
                </Form.Select>
              </InputGroup>
            </Col>
             */}
            
            {/*
            <Col>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Text id="phase">フェーズ</InputGroup.Text>
                <Form.Select aria-label="">
                  <option value="phase_all">すべて</option>
                  <option value="tehaitaisyou">手配対象</option>
                  <option value="torikomizumi">取り込み済み</option>
                  <option value="hattyuuzumi">発注済</option>
                  <option value="syorimati">処理待ち</option>
                  <option value="kakuninntyuu">※お客様に確認中※</option>
                  <option value="cancel">キャンセル</option>
                  <option value="makeriraizumi">メーカー直送依頼済み</option>
                </Form.Select>
              </InputGroup>
            </Col>

            <Col>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Text id="from">変更期間 From</InputGroup.Text>
                <Form.Control type="date" name="from" placeholder="" aria-describedby="from" />
              </InputGroup>
            </Col>

            <Col>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Text id="to">変更期間 to</InputGroup.Text>
                <Form.Control type="date" name="to" placeholder="" aria-describedby="to" />
              </InputGroup>
            </Col>
             */}

            
            <Col className="col-2">
              <InputGroup size="sm" className="mb-3 search-switch-flex">
                <div className="search-switch-label mx-1">検索対象　</div>
                <div className={switch_style_1}>ブラウザ</div>
                <Switch
                  className="mx-2"
                  checked={this.state.checked}
                  onChange={this.handleChange}
                />
                <div className={switch_style_2}>サーバー</div>
              </InputGroup>
            </Col>


            <Col>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Text>発注No.</InputGroup.Text>
                <Form.Control
                  aria-label="Small"
                  aria-describedby="hattyuu_no"
                  type="text"
                  maxLength="50"
                  id="hattyuu_no"
                />
              </InputGroup>
            </Col>


            <Col>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Text>KEY</InputGroup.Text>
                <Form.Control
                  aria-label="Small"
                  aria-describedby="order_key"
                  type="text"
                  maxLength="30"
                  id="order_key"
                />
              </InputGroup>
            </Col>

            <Col>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Text>JAN</InputGroup.Text>
                <Form.Control
                  aria-label="Small"
                  aria-describedby="jan"
                  type="text"
                  maxLength="13"
                  id="jan"
                />
              </InputGroup>
            </Col>

            <Col>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Text>管理番号</InputGroup.Text>
                <Form.Control
                  aria-label="Small"
                  aria-describedby="cm-order-no"
                  type="text"
                  maxLength="8"
                  id="cm-order-no"
                />
              </InputGroup>
            </Col>

            <Col className="col-1">
              <Button variant="outline-primary" id="search-submit" size="sm" type="submit"> 
                検索
              </Button>
              <Button variant="outline-secondary" id="search-clear-submit" size="sm" className="mx-1" onClick={event=>searchClearClick(event)} > 
                ｸﾘｱ
              </Button>
            </Col>

          </Row>	
    		</Form>
      </div>
    );
  }
}